import React from 'react';
export const EditOrReadOnlyContext = React.createContext({
  mode: "edit"
});

export const DataFormContext = React.createContext({
  labelAlign: "right",
  vertical: false,
  itemRef: () => {},
  formRef: {}
});
